module.exports = __webpack_public_path__ + "static/media/totalScans.693c5fb4.svg";